import { Button } from "@chakra-ui/react";
import { useAppDispatch } from "../store/hooks";
import { logout } from "../store/authSlice";
import { useNavigate } from "@tanstack/react-router";

const LogoutButton = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate({ to: "/login" });
  };

  return (
    <Button onClick={handleLogout} colorScheme="red" variant="outline">
      Logout
    </Button>
  );
};

export default LogoutButton;
